<template>
  <div class="tableHistorico card">
    <div v-show="this.$store.getters.$GetModalCancel.layout_extracao">
      <ModalEditLayout :idlayout="idlayout" :lista="this.listLayout" />
    </div>
    <table>
      <thead>
        <tr>
          <td style="border-top-left-radius: 8px">Descrição</td>
          <td>Imagem</td>
          <td>Data de Criação</td>

          <td style="border-top-right-radius: 8px">Opção</td>
          <!-- <td style="border-top-right-radius: 10px">OPÇÕES</td> -->
        </tr>
      </thead>
      <tbody v-for="l in listLayout" :key="l.id">
        <tr>
          <td style="display: none"></td>
          <td data-title="Descrição">{{ l.DESC_LAYOUT }}</td>
          <td data-title="Imagem">
            <img
              @click="
                clickPreview(
                  `${this.$store.state.ImgURL}layout_extracao/` +
                    `${l.PATH_LAYOUT}`
                )
              "
              :src="
                `${this.$store.state.ImgURL}layout_extracao/` +
                `${l.PATH_LAYOUT}`
              "
              width="80"
              height="80"
              alt=""
            />
          </td>
          <td data-title="Data de Criação">{{ ReformDate(l.created_at) }}</td>
          <td>
            <div class="buttons-group">
              <button class="button" @click="editar(l.ID)">
                <i class="fas fa-edit"></i>
              </button>
              <button class="button2" @click="deletelayout(l.ID)">
                <i class="fas fa-trash"></i>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { GetDataAllLayout } from "../../../controllers/LayoutExtrcao/GetDataAllLayout";
import ModalLayout from "../../../components/Modais/ModalLayoutExtracao/index.vue";
import ModalEditLayout from "../../../components/Modais/ModalLayoutExtracao/edit.vue";
import { DeleteDataAllLayout } from "../../../controllers/LayoutExtrcao/DeleteDataAllLayout";
export default {
  components: { ModalLayout, ModalEditLayout },
  async created() {
    const resp = await GetDataAllLayout();
    if (resp != undefined) {
      this.$store.commit("SetListLayout", resp.data.list);
    }
  },
  computed: {
    listLayout() {
      return this.$store.state.listLayout;
    },
  },
  data() {
    return {
      idlayout: 0,
      verEdit: false,
    };
  },
  methods: {
    async editar(id) {
      this.idlayout = id;

      this.$store.commit("MutationSetCancelModalLayoutExtra", true);

      const resp = await GetDataAllLayout();
      if (resp != undefined) {
        this.$store.commit("SetListLayout", resp.data.list);
      }
    },
    clickPreview(base64) {
      this.$swal.fire({
        imageUrl: base64,
        imageWidth: 700,
        imageHeight: 400,
        imageAlt: "Custom image",
      });
      //  this.$swal('Hello Vue world!!!');
    },
    ReformDate(date) {
      const data = new Date(date);
      let dia = ("0" + data.getDate()).slice(-2);
      let mes = ("0" + (data.getMonth() + 1)).slice(-2);
      let ano = data.getFullYear();

      return `${dia}/${mes}/${ano}`;
    },
    async deletelayout(id) {
      const toast = await this.$swal
        .fire({
          title: "Deseja excluir Layout de Extração?",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "green",
          cancelButtonColor: "#d33",
          confirmButtonText: "Confirmar",
        })
        .then((result) => {
          if (result.isConfirmed) {
            return true;
          }

          return false;
        });

      if (!toast) {
        return;
      }

      const res = await DeleteDataAllLayout(id);

      if (res.status == 201) {
        const Toast = await this.$swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", this.$swal.stopTimer);
            toast.addEventListener("mouseleave", this.$swal.resumeTimer);
          },
        });

        const resp = await GetDataAllLayout();
        if (resp != undefined) {
          this.$store.commit("SetListLayout", resp.data.list);
        }

        Toast.fire({
          icon: "success",
          title: res.data.message,
        });
      }
    },
  },
};
</script>

<style scoped>
.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: var(--white);
  background-clip: border-box;
  padding: 25px;
  overflow-x: scroll;
  box-shadow: 0 0.15rem 1.75rem 0 rgb(58 59 69 / 15%) !important;
}

.tableHistorico img {
  cursor: pointer;
}

/* .tableHistorico table {
  font-size: 14px;
} */

.viewprocess {
  height: 15vh;
  width: 10vw;
  background-color: var(--white);
  border: none;
  border-radius: 15px;
  color: var(--green);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.viewcont {
  display: flex;
  width: 100%;
}

.buttons-group {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 3px;
}

.button {
  background: var(--btnBlue);
  color: var(--white);
  padding: 6px;
  border-radius: 5px;
  border: 1px solid transparent;
}

.button2 {
  background: var(--red);
  color: var(--white);
  padding: 6px;
  border-radius: 5px;
  border: 1px solid transparent;
}

.labelborder {
  background: var(--green);
  color: var(--white);
  width: 2vw;
  min-width: 2vw;
  text-align: center;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  border-radius: 10px;
}

.table {
  width: 100%;
}
table {
  font-family: "Poppins", sans-serif;
}

tr {
  text-align: center;
  font-size: 0.8rem;
}

.titleContent {
  margin-top: 30px;
  text-align: center;
  color: var(--gray);
}

.buttons {
  margin-top: 3rem;
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;
}

.buttons .btnAnalise {
  width: 85%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.buttons .btnAnalise > div > h6 {
  color: var(--green);
  font-size: 1rem;
}
.tableHistorico {
  padding: 0;
  margin: 3rem 0;
}

.tableHistorico table tbody tr:hover {
  background: var(--white);
}

.button {
  background: var(--white);
  color: var(--blue);
  font-size: 16px;
  /* color: var(--white); */
  padding: 6px;
  border-radius: 5px;
  border: 1px solid transparent;
  transition: 0.5s;
}

.button:hover {
  background: var(--blue);
  color: var(--white);
}

.button2 {
  color: var(--red);
  font-size: 16px;
  background: var(--white);
  padding: 6px;
  border-radius: 5px;
  border: 1px solid transparent;
  transition: 0.5s;
}

.button2:hover {
  background: var(--red);
  color: var(--white);
}

@media (max-width: 800px) {
  .buttons .btnAnalise .quad {
    width: 45%;
  }

  .buttons {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    gap: 1rem;
  }
  .viewprocess {
    width: 100%;
    padding: 60px 0;
  }

  .buttons .btnAnalise {
    width: 100%;
    gap: 1rem;
  }

  .labelborder {
    width: 20vw;
  }
}

@media (max-width: 768px) {
  .buttons .btnAnalise .quad {
    width: 100%;
  }

  .buttons-group {
    width: 100%;
    justify-content: space-around;
  }

  .button,
  .button2 {
    font-size: 1.7rem;
  }

  .tableHistorico thead {
    display: none;
  }

  .tableHistorico table {
    border-radius: 10px 10px 0 0;
  }

  .tableHistorico td {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 0.8rem;
  }

  .tableHistorico td:nth-child(2) {
    background-color: var(--cinza);
  }

  .tableHistorico td:first-of-type {
    font-weight: bold;
    font-size: 1.2rem;
    text-align: center;
    display: flex;
    justify-content: center;
  }

  .tableHistorico td:not(:first-of-type):before {
    content: attr(data-title);
    display: block;
    font-weight: bold;
  }
}
</style>
